// Import model
import { UpdateSectionLineRequest } from '../models/UpdateSectionLineRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSectionLineRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSectionLineRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSectionLineRequest instance
   */
  static deserialize(json: string): UpdateSectionLineRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSectionLineRequest instance
   */
  static fromObject(obj: any): UpdateSectionLineRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSectionLineRequest');
    }


    const instance: UpdateSectionLineRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSectionLineRequest instances
   */
  static deserializeArray(json: string): UpdateSectionLineRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSectionLineRequest instance to a JSON string
   */
  static serialize(instance: UpdateSectionLineRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSectionLineRequest instance to a plain object
   */
  static toObject(instance: UpdateSectionLineRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of UpdateSectionLineRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSectionLineRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
